import htmlMutation from './mutations/html-mutation';

const createMutation = (action) => htmlMutation.create(action);

export default createMutation;
